import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberToCurrency',
    standalone: false
})
export class NumberToCurrencyPipe implements PipeTransform {

  public transform(val: number): string {
    return !isNaN(val) ? val.toCurrency() : '';
  }
}
